import { Editor } from '@generated/graphql';
import { ServerLaunchOption } from '@hooks/userPreferencesAtoms';
import posthog from 'posthog-js';

const IdePrefix = '://vscode-remote/ssh-remote+';
const PortSuffix = ':443';

type LaunchServerProps = {
  ide: Omit<ServerLaunchOption, 'none'>;
  browserUrlOverride?: string;
} & Pick<Editor, 'url' | 'serverPath' | 'workspaceId' | 'editorId'>;

export const launchServer = ({
  url,
  serverPath,
  ide,
  workspaceId,
  editorId,
  browserUrlOverride,
}: LaunchServerProps) => {
  posthog.capture('agent-studio:user_launch-server', {
    workspaceId,
    editorId,
    launchMethod: ide,
  });
  const ideUrl = `${IdePrefix}${url?.replace('https://', '').replace('.tyrell', '@tyrell') || ''}${PortSuffix}${serverPath || ''}`;
  if (ide === 'browser') {
    window.open(browserUrlOverride || `${url}/#${serverPath}`, '_blank');
  } else if (ide === 'cursor') {
    window.open(`cursor${ideUrl}`, '_self');
  } else if (ide === 'vscode') {
    window.open(`vscode${ideUrl}`, '_self');
  } else if (ide === 'windsurf') {
    window.open(`windsurf${ideUrl}`, '_self');
  }
};
